import * as React from "react";
import * as Styles from "./styles/ContainerStyles";
import { Container } from "@material-ui/core";

import PrivacyPolicyContainer from "../information-pages/PrivacyPolicyContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../services/TelemetryService";

function PrivacyPolicy() {
  const classes = Styles.ContainerStyles();

  return (
    <Container fixed className={classes.container}>
      <PrivacyPolicyContainer />
    </Container>
  );
}

export default withAITracking(reactPlugin, PrivacyPolicy, "PrivacyPolicy");
